import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import React from 'react'

const CoverProgressDialog = ({
  open,
  current = 0,
  total = 0,
  label = 'Cover',
}) => {
  const percent =
    total > 0 ? Math.round((Math.min(current, total) / total) * 100) : 0

  return (
    <Dialog open={open}>
      <DialogContent
        className="max-w-sm"
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>正在更换 Cover</DialogTitle>
          <DialogDescription>
            {label}：已处理 {current}/{total}
            {total > 1 ? ' 个组件' : ''}
            ，请稍候…
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="h-2.5 w-full overflow-hidden rounded-full bg-muted">
            <div
              className="h-full rounded-full bg-primary transition-all duration-200"
              style={{ width: `${percent}%` }}
            />
          </div>
          <p className="text-center text-sm text-muted-foreground">{percent}%</p>
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default CoverProgressDialog
